export default "__VITE_ASSET__BoHfmJZY__"